import { TabsPage } from './tabs.page';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticatedGuard } from './../../guards/authenticated.guard';

const routes: Routes = [
  {
    path: '',
    component: TabsPage,
    children: [
      {
        path: 'home',
        children: [
          {
            path: '',
            loadChildren: () => import('../home/home.module').then(m => m.HomePageModule)
          }
        ]
      },
      {
        path: 'profile',
        canActivate: [AuthenticatedGuard],
        children: [
          {
            path: '',
            loadChildren: () => import('../profile/profile.module').then(m => m.ProfilePageModule)
          }
        ]
      },
      {
        path: 'chat',
        canActivate: [AuthenticatedGuard],
        children: [
          {
            path: '',
            loadChildren: () => import('../chat/chat.module').then(m => m.ChatPageModule)
          }
        ]
      },
      {
        path: 'swops',
        canActivate: [AuthenticatedGuard],
        children: [
          {
            path: '',
            loadChildren: () => import('../swops/swops.module').then(m => m.SwopsPageModule)
          }
        ]
      },
      {
        path: '',
        redirectTo: '/tabs/home',
        pathMatch: 'full'
      },
    ]
  },
  {
    path: '',
    redirectTo: '/tabs/home',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TabsPageRoutingModule { }
